<script setup lang="ts">
definePageMeta({
  layout: 'blank',
  middleware: [
    async function (to) {
      async function goToHomePage() {
        return await navigateTo(localeLink('/'));
      }

      const { isAuthenticated } = storeToRefs(useAuthStore());

      if (isAuthenticated.value) {
        return await goToHomePage();
      }

      const { access_token } = to.query;

      const { setAuth } = useAuthStore();
      const { fetchUserProfile, userId } = useUserData();

      if (access_token) {
        // @ts-expect-error
        await setAuth({ data: { access_token: String(access_token) } })
          .then(async () => {
            if (isAuthenticated.value) {
              await setTimeout(async () => {
                const { ApiService } = useApiService();

                await ApiService.patch('/bff/users/save-history', {});

                if (userId.value) {
                  await goToHomePage();
                } else {
                  await fetchUserProfile()
                    .then(async () => {
                      await goToHomePage();
                    })
                    .catch(async () => {
                      await goToHomePage();
                    });
                }
              }, 10);
            }
          })
          .catch(async () => {
            await goToHomePage();
          });
      } else {
        await goToHomePage();
      }
    },
  ],
});

const isLoading = ref<boolean>(true);

// TODO: When is Popup
// if (window.opener) {
//   window.opener.postMessage('close');
// }

let timeoutId: number;

onMounted(() => {
  timeoutId = window.setTimeout(async () => {
    // navigate to home page after 8 seconds if has any bug
    await navigateTo(localeLink('/'));
  }, 8000);
});

onBeforeUnmount(() => {
  clearTimeout(timeoutId);
});
</script>

<template>
  <ClientOnly>
    <div :class="$style.signUpPage">
      <BaseLoading
        class="!bg-auth-bg-primary"
        :icon-loader="true"
        :show="isLoading"
      />
    </div>
  </ClientOnly>
</template>

<style module lang="scss">
.signUpPage {
  @apply w-full h-full p-5;
  @apply flex flex-col justify-center items-center;
}
</style>
